export default __webpack_public_path__ + "static/simon-5d44bed793c962c4aa9c86830e646f21.webp";